import { render, staticRenderFns } from "./bhd.vue?vue&type=template&id=6071f446&scoped=true&"
import script from "./bhd.vue?vue&type=script&lang=js&"
export * from "./bhd.vue?vue&type=script&lang=js&"
import style0 from "./bhd.vue?vue&type=style&index=0&id=6071f446&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6071f446",
  null
  
)

export default component.exports